import React from 'react';
import { IconProps } from './type';

export const ICFileInvoiceSubmitted: React.FC<IconProps> = ({
    height = 24,
    width = 24,
}) => {
    return (
        <svg
            fill="currentColor"
            viewBox="0 0 16 16"
            height={height}
            width={width}
        >
            <path d="M10.854 6.146a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0l-1.5-1.5a.5.5 0 11.708-.708L7.5 8.793l2.646-2.647a.5.5 0 01.708 0z" />
            <path d="M4 0a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V2a2 2 0 00-2-2H4zm0 1h8a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V2a1 1 0 011-1z" />
        </svg>
    );
};
